import React from 'react'
import { Typography } from 'antd'
import cn from 'classnames'

import styles from './Paragraph.module.css'

type ParagraphProps = {
  color?: string
  children: React.ReactNode
  style?: React.CSSProperties
}

const Paragraph: React.FC<ParagraphProps> = ({
  color = 'dark',
  children,
  style,
}) => {
  const colorClassName = `color-${color}`

  return (
    <Typography.Paragraph
      style={style}
      className={cn(styles.paragraph, {
        [styles[colorClassName]]: color,
      })}
    >
      {children}
    </Typography.Paragraph>
  )
}

export default Paragraph
